module.exports = __webpack_public_path__ + "assets/media/phone-and-tablet.d161bffe.svg";